<template>
   <!-- sign in start -->
    <section class="authentication-form">
      <div class="innerpage-decor">
      </div>
      <div>
        <h2 class="title text-center"><router-link to="/"><img :src='"../../assets/images/efunding-logo.png"' alt="logo-brand"></router-link></h2>

        <div class="card" v-if="!emailSuccess && !isLoading">
          <form class="theme-form" @submit.prevent="handleSubmit">
            <p class="text-center">Silahkan isi email anda.</p>
            <b-alert v-model="alert" variant="danger" dismissible>
              Email tidak terdaftar!
            </b-alert>
            <div class="form-group">
              <input type="email" class="form-control" v-model="email" required>
            </div>
            <button type="submit" class="form-control btn-primary">Kirim</button>
          </form>
        </div>
        <div class="card" v-else-if="emailSuccess && !isLoading">
          <div class="text-center">
            <p>Email untuk mengubah password telah dikirim!</p>
          </div>
        </div>
        <div class="card" v-if="isLoading">
          <div class="text-center">
            <b-spinner variant="warning"></b-spinner>
          </div>
        </div>

      </div>
    </section>
    <!-- sign in end-->
</template>

<script>
import User from '../../api/user'

export default {
  data() {
    return {
      email: '',
      isLoading: false,
      alert: false,
      emailSuccess: false
    }
  },
  methods: {
    handleSubmit() {
      this.emailSuccess = null
      this.isLoading = true
      User.forgotPassword({ email: this.email })
        .then(res => {
          if (res.data.meta.code == 200) {
            this.isLoading = false
            this.emailSuccess = true
          } else if (res.data.meta.code == 204) {
            this.isLoading = false
            this.alert = true
          }
        })
        .catch(err => console.log(err))
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/public/auth/ForgotPassword.vue